import {IconButton} from '#/components/buttons/icon-button';
import {ReactComponent as IconStatusLoading} from '#/components/icons/ico-status-loading.svg';
import {ArrowRightIcon} from '@heroicons/react/24/solid';
import {ComponentProps, FunctionComponent} from 'react';

type RightArrowLoadingButtonProps = {enabled: boolean; loading: boolean} & Omit<ComponentProps<'button'>, 'disabled'>;
export const RightArrowLoadingButton: FunctionComponent<RightArrowLoadingButtonProps> = ({
  loading,
  enabled,
  ...rest
}) => {
  return (
    <IconButton
      {...rest}
      className={`bg-deepblue rounded-full p-1 disabled:cursor-not-allowed hover:opacity-70 disabled:hover:opacity-100 ${
        loading ? '' : 'disabled:grayscale'
      }`}
      disabled={!enabled || loading}
      IconComponent={loading ? IconStatusLoading : ArrowRightIcon}
      iconClassName={loading ? 'w-4 h-4 animate-spin text-white fill-deepblue' : 'w-4 h-4 fill-white stroke-white'}
    />
  );
};
